import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import { Link } from 'react-router-dom';
import { resumenPlano } from '../utils/texto';
import { fechaRelativa } from '../utils/fecha';

function SliderNotas({ newsData, categoriesData }) {
    const filteredNews = categoriesData.map(category => {
        return newsData.find(news => news.category_id === category.id && news.number === 1);
    }).filter(Boolean);

    // const getFirstParagraphHtmlSecond = (html) => {
    //     const tempDiv = document.createElement('div');
    //     tempDiv.innerHTML = html;
    //     const p = tempDiv.querySelector('p');

    //     if (p) {
    //         let text = p.textContent || '';
    //         if (text.length > 100) {
    //             text = text.substring(0, 100) + '...';
    //         }
    //         return `<p>${text}</p>`;
    //     }

    //     let text = tempDiv.textContent || '';
    //     if (text.length > 100) {
    //         text = text.substring(0, 100) + '...';
    //     }
    //     return `<p>${text}</p>`;
    // };

    // Los cuerpos guardados desde el editor vienen sembrados de &nbsp;. Un
    // espacio duro no permite cortar la linea, asi que el extracto se convertia
    // en una sola linea indivisible que se salia de la tarjeta. Se normalizan a
    // espacios normales antes de recortar.

    const MAX_POR_VISTA = 4;
    const puedeHacerBucle = filteredNews.length > MAX_POR_VISTA * 2;

    return (
        <Swiper
            modules={[Navigation, Pagination, A11y, Autoplay]}
            spaceBetween={30}
            slidesPerView={4}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            loop={puedeHacerBucle}
            watchOverflow={true}
            touchRatio={1.5}
            grabCursor={true}
            speed={650}
            breakpoints={{
                300: {
                    slidesPerView: 1,
                },
                480: {
                    slidesPerView: 2,
                },
                640: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 4,
                },
                1024: {
                    slidesPerView: MAX_POR_VISTA,
                },
            }}
        >
            {filteredNews.map(news => (
                <SwiperSlide key={news.id}>
                    <Link to={`/noticias/${news.id}`}>
                        <div className="ed-tarjeta">
                            <div className="ed-tarjeta__foto">
                                <img
                                    src={news.image_url}
                                    alt={news.title}
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>
                            <h2 className="slider-text_notas ed-tarjeta__titulo">{news.title}</h2>
                            <p className="ed-tarjeta__extracto">{resumenPlano(news.body, 100)}</p>
                            <p className="ed-tarjeta__fecha">
                                {fechaRelativa(news.fecha_publicacion || news.updated_at || news.created_at)}
                            </p>
                        </div>
                    </Link>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}

export default SliderNotas;
